import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CardModule } from 'primeng/card';
import { TabViewModule } from 'primeng/tabview';
import { Subscription } from 'rxjs';
import { filter, startWith } from 'rxjs/operators';

import { CommonService } from '../../services/common.service';
import { MenuTabItems } from '../../models/common';

@Component({
  selector: 'via-tabs',
  standalone: true,
  templateUrl: './tabs.component.html',
  styleUrls: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TabViewModule,
    CardModule,
  ],
})
export class TabsComponent implements OnInit, OnDestroy {
  @Input() menuTabs: MenuTabItems[] = [];
  @Input() isTransparentBG = false;
  @Input() relativeToParent = false;
  @Input() activeIndex!: number;
  @Output() tabChange = new EventEmitter<number>();
  subscription!: Subscription;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService
  ) {}

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    if (history.state?.navId === 0 || history.state?.navId) {
      this.activeIndex = history.state?.navId;
    } else {
      this.activeIndex = 0;
    }

    // TODO: Apply integrate routing strategy
    this.subscription = this.router.events
      .pipe(
        filter((event: any) => event instanceof NavigationEnd),
        startWith(this.router)
      )
      .subscribe(() => {
        const rt = this.commonService.getActivatedRouteChild(
          this.activatedRoute
        );
        rt.data.subscribe((data: any) => {
          if (data.navigationIndex) {
            this.activeIndex = data.navigationIndex;
          } else {
            const currentTabByUrl = this.menuTabs.findIndex(
              (tab) => this.router.url.indexOf(tab.navUrl) > -1
            );
            this.activeIndex = currentTabByUrl > -1 ? currentTabByUrl : 0;
          }
          if (history.state?.navId === 0 || history.state?.navId) {
            this.activeIndex = history.state?.navId;
          }
        });
      });
  }

  tabularRouting({ index }: { index: number }) {
    this.router.navigate([this.menuTabs[index].navUrl], {
      relativeTo: this.relativeToParent
        ? this.activatedRoute.parent
        : this.activatedRoute,
      state: { navId: index },
    });
  }

  tabChangeHandler(event: number) {
    this.tabChange.emit(event);
  }
}
